import { REMINDER_VIEW_COLUMNS, REMINDER_VIEW_FILTER_FIELD_CONFIG } from "./ReminderView/reminderViewColumnsData.js";
import { PERSISTENCE_STATE_KEYS } from "./PersistenceStateKeys.jsx";
import {
  cellMenuItemCollapseAllRows,
  cellMenuItemCollapseRow,
  cellMenuItemRemoveRow, cellMenuItemSettingsEditor,
} from "../utils/gridCellMenuUtils.jsx";
import {SWIVU_GROUP_CONTEXT_MENU_SELECTOR} from "./OtherKeys.jsx";
import SwivuCellEditor from "../../bryntum-lib/widget/fields/SwivuCellEditor.jsx";

const REMINDERS_GRID_CONFIG = {
  columns: REMINDER_VIEW_COLUMNS,
  // Todo: On Notify Grid, This checkbox cause an issue, when opening a context menu from group header 3 dots, menu not opens. Need to proper fix.
  selectionMode: {
    checkboxOnly: true,
    showCheckAll: true,
    checkbox: {
      id: "reminder-checkbox",
      enableHeaderContextMenu: false
    },
  },
  stateId: PERSISTENCE_STATE_KEYS.remindersView,
  filterFeature: {
    pickerConfig: {
      fields: REMINDER_VIEW_FILTER_FIELD_CONFIG
    },
    closeEmptyPopup: true
  },
  statefulEvents: [
    "subGridCollapse",
    "subGridExpand",
    "horizontalScroll",
    "stateChange",
    "scroll",
    "swivuAllReminderStoreStoreFilter",
    "swivuAllReminderStoreStoreSort",
    "swivuAllReminderStoreStoreGroup"
  ],
  cellEditFeature: { editorClass: SwivuCellEditor },
  rowCopyPasteFeature: false,
  rowReorderFeature: false,
  cellMenuFeature: {
    clickTriggerSelector: SWIVU_GROUP_CONTEXT_MENU_SELECTOR,
    items: {
      cut: false,
      copy: false,
      paste: false,
      filterStringEquals: false,
      filterDisable: false,
      filterMenu: false,
      removeRow: cellMenuItemRemoveRow(),
      collapseRow: cellMenuItemCollapseRow(),
      collapseAllRows: cellMenuItemCollapseAllRows(),
      settingsEditor: cellMenuItemSettingsEditor(),
    }
  }
};

export { REMINDERS_GRID_CONFIG };
